import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";

const ManageGreekBox = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      name: 'Greek Essential Box',
      BoxArt: "Wild Berries, Bees, Lavender",
      Flavours: "9",
      Toppings: "18",
      Price: "25.000 KD",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: 'Greek Essential Box',
      BoxArt: "Wild Berries, Bees, Lavender",
      Flavours: "9",
      Toppings: "18",
      Price: "25.000 KD",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 3,
      name: 'Greek Essential Box',
      BoxArt: "Wild Berries, Bees, Lavender",
      Flavours: "9",
      Toppings: "18",
      Price: "25.000 KD",
      createdDate: "01-Sept-2025",
      status: true,
    }
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Greek Box</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Greek Box
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-greek-box/add")}
            >
              <AddIcon /> Add Greek Box
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Box Name</TableCell>
                <TableCell>Box Art</TableCell>
                <TableCell>Flavours Limits</TableCell>
                <TableCell>Toppings Limits</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Featured</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.BoxArt}</TableCell>
                  <TableCell>
                    Min: <strong>{row.Flavours}</strong>
                    <br />
                    Max: <strong>{row.Flavours}</strong>
                  </TableCell>
                  <TableCell>
                    Min: <strong>{row.Toppings}</strong>
                    <br />
                    Max: <strong>{row.Toppings}</strong>
                  </TableCell>
                  <TableCell>{row.Price}</TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate("/manage-greek-box/add")}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageGreekBox;
